/** Port of Python utils.create_circle_points / JS callback.createCirclePoints */
const EARTH_RADIUS = 6371;

export function createCirclePoints(
  centerLon: number,
  centerLat: number,
  radiusKm: number,
  numPoints = 64
): [number, number][] {
  const radiusRad = radiusKm / EARTH_RADIUS;
  const centerLatRad = (centerLat * Math.PI) / 180;
  const centerLonRad = (centerLon * Math.PI) / 180;

  const points: [number, number][] = [];
  for (let i = 0; i < numPoints; i++) {
    const angle = (2 * Math.PI * i) / numPoints;
    const latRad = Math.asin(
      Math.sin(centerLatRad) * Math.cos(radiusRad) +
        Math.cos(centerLatRad) * Math.sin(radiusRad) * Math.cos(angle)
    );
    const lonRad =
      centerLonRad +
      Math.atan2(
        Math.sin(angle) * Math.sin(radiusRad) * Math.cos(centerLatRad),
        Math.cos(radiusRad) - Math.sin(centerLatRad) * Math.sin(latRad)
      );
    const lon = ((((lonRad * 180) / Math.PI) % 360) + 540) % 360 - 180;
    const lat = (latRad * 180) / Math.PI;
    points.push([lon, lat]);
  }
  // Close the polygon
  points.push(points[0]);
  return points;
}
